<template>
    <div :class="{'show': show}" class="row filter-row">
        <aside class="filter-bar col-sm-12">
            <form class="form">
                <div class="container-fluid h-100">
                    <div class="row align-items-center">


                        <div class="col form-group filter-select open-filter">
                            <button @click.prevent="openFilterBar()" class="btn btn-primary btn-block">Filter öffnen</button>
                        </div>

                        <div class="col form-group filter-select">
                            <label class="d-inline-block" for="campaignFilter">Aktionen</label>
                            <select v-model="filters.campaign" class="form-control" id="campaignFilter">
                                <option value="" selected disabled hidden>Filter auswählen</option>
                                <option v-for="campaign in stationCampaigns" :value="campaign.name">
                                    {{campaign.display_name}}
                                </option>
                            </select>
                        </div>

                        <div class="col form-group filter-select">
                            <label class="d-inline-block" for="fuelFilter">Kraftstoffe</label>
                            <select v-model="filters.fuel" class="form-control" id="fuelFilter">
                                <option value="" selected disabled hidden>Filter auswählen</option>
                                <option v-for="fuel in stationFuels" :value="fuel.name">
                                    {{fuel.display_name}}
                                </option>
                            </select>
                        </div>

                        <div class="col form-group filter-select">
                            <label class="d-inline-block" for="paymentMethodeFilter">Zahlarten</label>
                            <select v-model="filters.paymentMethod" @change="updateFilters()" class="form-control" id="paymentMethodeFilter">
                                <option value="" selected disabled hidden>Filter auswählen</option>
                                <option v-for="paymentMethode in stationPaymentMethodes" :value="paymentMethode.name">
                                    {{paymentMethode.display_name}}
                                </option>
                            </select>
                        </div>

                        <div class="col form-group filter-select">
                            <label class="d-inline-block" for="serviceFilter">Services</label>
                            <select v-model="filters.service" @change="updateFilters()" class="form-control" id="serviceFilter">
                                <option value="" selected disabled hidden>Filter auswählen</option>
                                <option v-for="service in stationServices" :value="service.name">
                                    {{service.display_name}}
                                </option>
                            </select>
                        </div>

                        <div class="col form-group filter-select">
                            <button @click.prevent="resetFilters()" class="btn btn-primary btn-block">Filter zurücksetzen</button>
                        </div>

                        <div class="col form-group filter-select close-filter">
                            <button @click.prevent="closeFilterBar()" class="btn btn-primary btn-block">Filter schließen</button>
                        </div>


                        <slot></slot>
                    </div>
                </div>
            </form>
        </aside>
    </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  export default {
    components: {
    },
    props: {
    },
    data() {
      return {
          show: false
      }
    },
    mounted () {
    },
    methods: {
      ...mapActions([
          'resetFilters',
          'setFilters',
          'filterStations'
      ]),
        toggleFilterBar () {
          this.show = !this.show
        },
        closeFilterBar () {
          this.show = false
        },
        openFilterBar () {
            this.show = true
        },
        updateFilters () {
            this.setFilters(this.filters)
            this.$emit('updatedFilter')
        }
    },
    computed: {
      ...mapGetters({
          filters: 'filters',
        stations: 'stations',
        selectedStation: 'selectedStation',
        stationCampaigns: 'stationCampaigns',
        stationFuels: 'stationFuels',
        stationPaymentMethodes: 'stationPaymentMethodes',
        stationServices: 'stationServices'
      })
    },
    filters: {
      clean: function (value) {
        if (!value) return ''
        value = value.toString()
        return value.replace(/-/g, ' ').toUpperCase()
      }
    }
  }
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// stationFilterSidebar.vue?449018eb